import request from '@/utils/request'

let DynamicsApi = {

  /*动态列表*/
  list(data) {
    return request._post('/shop/plus.dynamics.Index/index', data);
},
/*添加动态*/
add(data) {
    return request._post('/shop/plus.dynamics.Index/add', data);
},
/*修改动态*/
edit(data) {
    return request._post('/shop/plus.dynamics.Index/edit', data);
},
/*删除动态*/
del(data) {
    return request._post('/shop/plus.dynamics.Index/del', data);
},
/*删除动态*/
audit(data) {
    return request._post('/shop/plus.dynamics.Index/audit', data);
},
/*动态详情*/
detail(data) {
  return request._post('/shop/plus.dynamics.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.dynamics.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.dynamics.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.dynamics.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.dynamics.Index/export', data);
    },
}
export default DynamicsApi;



// WEBPACK FOOTER //
// ./src/api/dynamics.js